module.exports = {"ServerUrl9":"http://localhost:63220/","ServerUrl2":"http://TestApi.Toliton.ir/","ServerUrl1":"http://Api.Toliton.ir/","ServerUrl":"http://TolitonApi.Alireza-Azizi.ir/","ServerUrl4":"https://45.82.137.139/"}


//////////////////
// WEBPACK FOOTER
// ./engine/addresses.json
// module id = 1964
// module chunks = 0